import { Component, OnInit } from '@angular/core';
import { trigger, style, animate, transition, state } from '@angular/animations';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../../../shared/_services/authentication.service'
import { first } from 'rxjs/operators';
import { User } from '../../../shared/models/user.model';

@Component({
  selector: 'app-join-app',
  templateUrl: './join-app.component.html',
  styleUrls: ['../login.component.css'],
  animations: [
    trigger('enterState', [
      state('void', style({
        opacity: 0.2,
        transform: 'translateX(-100%)'
      })),
      transition(':enter', [
        animate(300, style({
          opacity: 1,
          transform: 'translateX(0)'
        }))
      ])
    ])
  ]
})
export class JoinAppComponent implements OnInit {

  loginForm: FormGroup;
  submitted = false;
  returnUrl: string;
  error = '';

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService
  ) {
    //// redirect to home if already logged in and fist-time is != null
    //if (this.authenticationService.currentUserValue && this.authenticationService.currentUserValue.firstEntryDate) {
    //  this.router.navigate(['/home']);
    //} else {
    //  this.authenticationService.logout();
    //}  
  }
  ngOnInit() {
    this.loginForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    });
    // get return url from route parameters or default to '/'
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
  }

  // convenience getter for easy access to form fields
  get f() { return this.loginForm.controls; }

  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.loginForm.invalid) {
      return;
    }

    this.authenticationService.login(this.f.username.value, this.f.password.value)
      .pipe(first())
      .subscribe(data => {
        this.router.navigate([this.returnUrl]);
      },
        error => {
          this.error = error;
        });
  }

  //  validarRedireccion(data: User) {

  //      console.log("");
  //    //Valida primer ingreso   
  //    if (data.firstEntryDate == null) {
  //      this.returnUrl ='/login/first-time';
  //    }
  //    //Valida si la contraseñaes temporal y no es el primer ingreso  , recupero contraseña o le generaron contraseña
  //    if ((data.firstEntryDate && data.temporalPassword) || data.expiredPassword) {
  //      this.returnUrl = '/login/change-password';
  //    }

  //    this.router.navigate([this.returnUrl]);
  //}

}

